import React from "react";
import { useAudio } from "../audio/AudioContext";
import "./MiniPlayer.css";

export default function MiniPlayer() {
  const { current, playing, progress, duration, play, pause, audioRef } =
    useAudio();

  if (!current) return null;

  const toggle = () => {
    playing ? pause() : play(current);
  };

  const seek = (e) => {
    audioRef.current.currentTime = e.target.value;
  };

  const format = (s) => {
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60).toString().padStart(2, "0");
    return `${m}:${sec}`;
  };

  return (
    <div className="mini-player">
      <img
        src={`https://live-evo.com/${current.cover_path}`}
        alt=""
      />

      <div className="mini-info">
        <strong>{current.title}</strong>
        <span>{current.artist}</span>

        <input
          type="range"
          min="0"
          max={duration}
          value={progress}
          onChange={seek}
        />

        <div className="time">
          {format(progress)} / {format(duration)}
        </div>
      </div>

      <button onClick={toggle}>
        {playing ? "⏸" : "▶"}
      </button>
    </div>
  );
}
